import { useCallback } from 'react';

import type { ActionsReturnType, GroupSharingHookProps } from './types';

// TODO: Implement. Ideally this hook can be used for both Reddit group sharing and Reddit post sharing since they behave
// exactly the same.
export function useRedditGroupPostSharing(_input: GroupSharingHookProps): ActionsReturnType {
	const primaryAction = useCallback(() => {}, []);
	const secondaryAction = useCallback(() => {}, []);

	return {
		primaryAction,
		secondaryAction,
	};
}
